<div class="loader">
  <span class="loader-ellipsis"></span>
  @if (loaderText) {
    <span class="loader-text">{{ loaderText }}</span>
  }
</div>
